module.exports = __webpack_public_path__ + "img/bf-logo-no-smile.54407d9c.svg";